var FieldType = /* @__PURE__ */ ((FieldType2) => {
  FieldType2["DateTime"] = "datetime";
  FieldType2["Number"] = "number";
  FieldType2["BigNumber"] = "bignumber";
  return FieldType2;
})(FieldType || {});
export {
  FieldType
};
